import React from 'react';
import { Button } from 'antd';
import Image from '../images/banner_carousel.webp';
import { useNavigate } from 'react-router-dom';
import '../styles/Carousel.css'; // Import the CSS file

const Carousel = ({ setSelected }) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    setSelected('Nuestra Fé'); // Update the selected state in Navbar
    navigate('/nuestra_fe'); // Navigate to the Nuestra Fé page
  };

  return (
    <div
      id="nuestra-fe"
      className="carousel-container"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${Image})`,
      }}
    >
      {/* Overlay Content */}
      <div className="carousel-overlay">
        <h1 className="carousel-title">
          Iglesia Visión Apostólica Lomas de Tafí
        </h1>
        <p className="carousel-description">
          Somos una Iglesia Cristiana centrada en Jesucristo y su Palabra.
          Llevamos a nuestros miembros a expresar el objetivo bíblico de vivir
          para Dios y para los demás.
          <br /> Nos encontramos en la ciudad de Tafí Viejo, provincia de
          Tucumán.
        </p>
        <Button
          type="primary"
          size="large"
          className="carousel-button"
          onClick={handleButtonClick}
        >
          Conocer más
        </Button>
      </div>
    </div>
  );
};

export default Carousel;
